import {Component} from '@angular/core';

@Component({
    selector: 'course-exercises-support-article',
    template: `
        <ng-container i18n="@@support.articles.exercises">
            <p>As an instructor you can create extra exercises for your students. This enables you to, for example, set up tests to assess the typing skills of your students.</p>
            <p>You can also use exercises from other instructors within your organization if they enabled this.</p>
        </ng-container>
    `
})
export class ExercisesSupportArticleComponent {
}
